export function isActiveSubscription(status) {
  return status === 'active' || status === 'trialing';
}
